import React from 'react';
import './styles/loading.scss';

export default class Loading extends React.Component {
  render() {
    return (
      // <div className="background-fade">
      <div className={`loading-container ${this.props.loading ? 'shown' : 'hidden'}`} style={this.props.location}>
        <img className="loading-spinner" src={process.env.PUBLIC_URL + '/proasys_alt.png'} alt="loading-icon" height={this.props.height || '80px'}/>
        {/* <video id="banner-video" autoPlay muted playsInline loop height="80px">
          <source src={process.env.PUBLIC_URL + '/proasys_spinner_alpha.webm'} type="video/webm"/>
        </video> */}
        <span className="loading-text">{this.props.loadingMessage}</span>
      </div>
    )
  }
}
